// import React from "react";
// import ClientNavbar from "../layout/ClientNavbar";

// export default function TotalApplication() {
//   return (
//     <div className="container-fluid">
//       <div className="row min-vh-100">
//         {/* Sidebar */}
//         <div className="col-md-2 p-0">
//           <ClientNavbar />
//         </div>

//         {/* Main Content */}
//         <div
//           className="col-md-10 py-5 px-4"
//           style={{
//             background:
//               "linear-gradient(135deg, rgb(240, 253, 253) 0%, rgba(155, 222, 218, 0.73) 50%, rgb(3, 186, 187) 100%)",
//             minHeight: "100vh",
//           }}
//         >
//           <div className="card shadow-sm p-4" style={{ borderRadius: "16px" }}>
//             <h4 className="fw-bold mb-4">Total Applications</h4>

//             <div className="table-responsive">
//               <table className="table table-bordered align-middle">
//                 <thead style={{ backgroundColor: "#FFE6DC" }}>
//                   <tr>
//                     <th>Application No.</th>
//                     <th>Loan Type</th>
//                     <th>Date</th>
//                     <th>Loan Amount</th>
//                     <th>Loan Progress</th>
//                     <th>Application Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td className="text-primary fw-semibold">COLA250925</td>
//                     <td>Home Loan</td>
//                     <td>24 Sep, 2025</td>
//                     <td>₹ 2,00,000</td>
//                     <td>
//                       <div
//                         className="progress"
//                         style={{ height: "8px", backgroundColor: "#e9ecef" }}
//                       >
//                         <div
//                           className="progress-bar"
//                           style={{
//                             width: "40%",
//                             backgroundColor: "#00bcd4",
//                           }}
//                         ></div>
//                       </div>
//                       <small className="text-muted">40% Completed</small>
//                     </td>
//                     <td>
//                       <span
//                         className="badge rounded-pill"
//                         style={{
//                           backgroundColor: "#ff6600",
//                           color: "#fff",
//                           fontSize: "0.9rem",
//                           padding: "8px 16px",
//                         }}
//                       >
//                         Pending
//                       </span>
//                     </td>
//                   </tr>

//                   <tr>
//                     <td className="text-primary fw-semibold">COLA250924</td>
//                     <td>CC/OD - Secured</td>
//                     <td>24 Sep, 2025</td>
//                     <td>₹ 2,00,000</td>
//                     <td>
//                       <div
//                         className="progress"
//                         style={{ height: "8px", backgroundColor: "#e9ecef" }}
//                       >
//                         <div
//                           className="progress-bar"
//                           style={{
//                             width: "40%",
//                             backgroundColor: "#00bcd4",
//                           }}
//                         ></div>
//                       </div>
//                       <small className="text-muted">40% Completed</small>
//                     </td>
//                     <td>
//                       <span
//                         className="badge rounded-pill"
//                         style={{
//                           backgroundColor: "#ff6600",
//                           color: "#fff",
//                           fontSize: "0.9rem",
//                           padding: "8px 16px",
//                         }}
//                       >
//                         Pending
//                       </span>
//                     </td>
//                   </tr>

//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div className="d-flex justify-content-between align-items-center mt-4">
//               <div>
//                 <select className="form-select d-inline-block" style={{ width: "80px" }}>
//                   <option>10</option>
//                   <option>20</option>
//                   <option>50</option>
//                 </select>
//               </div>

//               <div className="d-flex align-items-center">
//                 <button className="btn btn-light btn-sm me-2">&laquo;</button>
//                 <button
//                   className="btn btn-danger btn-sm"
//                   style={{
//                     borderRadius: "50%",
//                     width: "36px",
//                     height: "36px",
//                   }}
//                 >
//                   1
//                 </button>
//                 <button className="btn btn-light btn-sm ms-2">&raquo;</button>
//               </div>

//               <div>
//                 <span>1 - 2 of 2</span>
//               </div>
//             </div>

//             {/* Back Button */}
//             <div className="mt-4">
//               <button className="btn btn-outline-dark px-4">Back</button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useContext, useEffect, useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import axios from "axios";
import { Link } from "react-router-dom";
import locContext from "../context/locContext";
import { NavLink } from "react-router-dom";

export default function TotalApplication() {
  const { userData } = useContext(locContext);
  const id = userData?.id || null;

  const [data, setData] = useState([]);
  const getLoanApplicationData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/loan-application/user/${id}`,
      );
      if (res.status === 200) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getLoanApplicationData();
  }, []);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Pagination logic
  const totalPages = Math.ceil(data.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); // reset to first page
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Total Applications</h3>
            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientloan">Apply For Loan</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Total Applications
                </li>
              </ol>
            </nav>
          </div>
          <div className="card shadow-sm p-4 mb-4">
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead
                  style={{ backgroundColor: "#FFE6DC", whiteSpace: "nowrap" }}
                >
                  <tr>
                    <th>Application No.</th>
                    <th>Loan Type</th>
                    <th>Application Date</th>
                    <th>Loan Amount</th>
                    <th>Market Value</th>
                    <th>Phone</th>
                    <th>PAN</th>
                    <th>Category</th>
                    <th>Type</th>
                    <th>Profession</th>
                    <th>Industry</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((app, index) => (
                    <tr key={index} style={{ whiteSpace: "nowrap" }}>
                      <td className="text-primary fw-semibold">
                        {app.application_code}
                      </td>
                      <td>{app.loan_type}</td>
                      <td>{app.application_date.split("T")[0]}</td>
                      <td>
                        {Number(app.loan_amount).toLocaleString("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {Number(app.market_value).toLocaleString("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}
                      </td>

                      <td>{app.user_phone || "-"}</td>
                      <td>{app.user_pan || "-"}</td>
                      <td>{app.loan_category || "-"}</td>
                      <td>{app.loan_type || "-"}</td>
                      <td>{app.profession || "-"}</td>
                      <td>{app.industry || "-"}</td>

                      {/* <td>
                        <div
                          className="progress"
                          style={{ height: "8px", backgroundColor: "#e9ecef" }}
                        >
                          <div
                            className="progress-bar"
                            style={{
                              width: `${app.progress}%`,
                              backgroundColor: "#00bcd4",
                            }}
                          ></div>
                        </div>
                        <small className="text-muted">
                          {app.progress}% Completed
                        </small>
                      </td> */}
                      {/* <td>
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor:
                              app.status === "Approved" ? "#28a745" : "#ff6600",
                            color: "#fff",
                            fontSize: "0.9rem",
                            padding: "8px 16px",
                          }}
                        >
                          {app.status}
                        </span>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap">
              {/* Rows per page */}
              <div className="mb-2">
                <select
                  className="form-select d-inline-block"
                  style={{ width: "80px" }}
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>

              {/* Pagination buttons */}
              <div className="d-flex align-items-center mb-2">
                <button
                  className="btn btn-primary me-2"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  &laquo;
                </button>

                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    className={`btn btn-sm mx-1 ${
                      currentPage === index + 1
                        ? "btn-danger"
                        : "btn-outline-secondary"
                    }`}
                    style={{
                      borderRadius: "50%",
                      width: "36px",
                      height: "36px",
                    }}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}

                <button
                  className="btn btn-primary ms-2"
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  &raquo;
                </button>
              </div>

              {/* Showing range */}
              <div className="mb-2">
                <span>
                  {indexOfFirstRow + 1}-{rowsPerPage} of {rowsPerPage}
                </span>
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-4">
              <Link to="/clientloan" className="text-decoration-none text-dark">
                <button className="btn btn-primary px-4">Back</button>
              </Link>
            </div>
          </div>
        </div>
    </>
  );
}
